export default __webpack_public_path__ + "static/media/bg.4320bd98.jpg";